import { render, staticRenderFns } from "./questionBank_info_list_set_type_15.vue?vue&type=template&id=ce246faa&scoped=true"
import script from "./questionBank_info_list_set_type_15.vue?vue&type=script&lang=js"
export * from "./questionBank_info_list_set_type_15.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce246faa",
  null
  
)

export default component.exports